import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { DashSortableService } from "../../../../modules/home/dash/service/dash.sortable.service";
import { HomeDashPanelTypeId, type HomeDashCustomize } from "../panel/home.dash.panel.model";
import type { HomeDashPanelModel } from "../panel/home.dash.panel.model";
import type { HomeDashSectionModel } from "./home.dash.section.model";
import { HomeDashPanelComponent } from "../panel/home.dash.panel.component";
import { S25PanelMoveOverlayComponent } from "../../../../modules/s25-movable/s25.panel.move.overlay.component";
import { HomeDashSortableListDirective } from "../sortable/home.dash.sortable.list.directive";

@Component({
    selector: "s25-ng-dash-section-regular",
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HomeDashPanelComponent, S25PanelMoveOverlayComponent, HomeDashSortableListDirective],
    template: `
        <div class="section-regular">
            <div
                class="col-normalized-height sortable-group"
                s25DashSortableList
                [s25DashSortableList]="section().panels"
                [s25DashSortableDisabled]="!sortable()"
                [s25DashSortableToolbox]="isToolbox()"
            >
                @for (panel of section().panels; track panel.panelId) {
                    <div
                        class="d-panel section"
                        [class.dash-panel--move-selected]="customize().selectedMovePanelId() === panel.panelId"
                        [attr.panel-id]="panel.panelId"
                        [attr.panel-type-id]="panel.typeId"
                    >
                        <s25-ng-dash-panel
                            [panel]="panel"
                            [isToolbox]="isToolbox()"
                            [customize]="customize()"
                            [showHeader]="showPanelHeader(panel)"
                        />
                        @if (customize().selectedMovePanelId() === panel.panelId) {
                            <s25-ng-panel-move-overlay
                                [compact]="isToolbox()"
                                [ariaLabel]="'Move panel'"
                                (move)="customize().moveSelectedPanel($event)"
                            />
                        }
                    </div>
                }
            </div>
        </div>
    `,
    styles: `
        :host {
            display: block;
        }

        .d-panel.section {
            position: relative;
        }

        .d-panel.section.dash-panel--move-selected {
            /* Keep move controls above neighboring floated toolbox tiles */
            z-index: 6;
        }
    `,
})
export class HomeDashSectionRegularComponent {
    readonly section = input.required<HomeDashSectionModel>();
    /** Main dashboard columns omit this input; toolbox passes `true`. */
    readonly isToolbox = input(false);
    readonly customize = input.required<HomeDashCustomize>();

    private readonly dashSortableService = inject(DashSortableService);
    readonly sortable = computed(() => this.dashSortableService.isSortable());

    showPanelHeader(panel: HomeDashPanelModel): boolean {
        return this.isToolbox() || panel.typeId !== HomeDashPanelTypeId.ExpressSchedulingReserveOnly;
    }
}
